<template>
  <PortalPageShell
    title="Claim Manager"
    :subtitle="$t('portal.claimManager')"
  >
    <ManageClaim
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageClaim from '../components/claim/ManageClaim.vue';

export default {
  components: {
    PortalPageShell,
    ManageClaim,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
